import React, { Component } from "react";
import { FcManager } from "react-icons/fc";
import { Main_Color } from "../../Theme/Theme";
import Backend from "../../Backend/Backend";
import { useAlert } from "react-alert";
import Modal from "@mui/material/Modal";
import ProductCard from "./ProductCard";
import Add from "./Add/Add";
import Edit from "./Edit/Edit";
import Stock from "./Stock/Stock";
import Image from "./Image/Image";

const backend = new Backend();
const Product = () => {
  const [open, setOpen] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [token, setToken] = React.useState(localStorage.getItem("token"));
  const [adminid, setAdminid] = React.useState(localStorage.getItem("adminid"));
  const [edit_modal, setEdit_modal] = React.useState(false);
  const [image, setStock_image] = React.useState(false);
  const [editdata, setEditData] = React.useState("");
  const [stock_modal, setStock_modal] = React.useState(false);
  const [stockdata, setStockData] = React.useState("");
  const alert = useAlert();

  React.useEffect(() => {
    loadconent();
  }, []);

  const loadconent = () => {
    setLoading(true);
    var data = {
      token: token,
      admin_id: adminid,
    };
    backend.load_product(data).then((r) => {
      if (r.error === "False") {
        setData(r.data);
        setLoading(false);
      } else {
        alert.error("You just broke something!");
        setLoading(false);
      }
    });
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => setOpen(false);

  const handleOpen_edit = (i) => {
    setEditData(i);
    setEdit_modal(true);
  };

  const handleClose_edit = () => {
    setEdit_modal(false);
    setEditData("");
  };

  const handleOpen_stock = (i) => {
    setStockData(i);
    setStock_modal(true);
  };

  const handleClose_stock = () => {
    setStock_modal(false);
    setStockData("");
  };

  const handleOpen_Image = (i) => {
    setEditData(i);
    setStock_image(true);
  };

  const handleClose_Image = () => {
    setStock_image(false);
    setEditData("");
  };
  return (
    <div style={{ flex: 1, backgroundColor: "#f2f2f2" }}>
      <div
        style={{
          display: "flex",
          height: "100px",
          backgroundColor: "#ffffff",
          flex: 1,
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            padding: 20,
            color: Main_Color,
            fontSize: 22,
            paddingLeft: 40,
            flex: 1,
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >
          <FcManager style={{ fontSize: 55 }} />
          <div style={{ paddingLeft: 20, fontSize: 22 }}>Product</div>
        </div>
        {/* <div
          onClick={handleOpen}
          style={{
            display: "flex",
            padding: 20,
            color: Main_Color,
            fontSize: 22,
            paddingRight: 40,
          }}
        >
          <BsPlusSquareFill style={{ fontSize: 40 }} />
        </div> */}
      </div>

      <div style={{ padding: 10 }}>
        <div
          style={{
            flex: 1,
            height: "83vh",
            borderRadius: 10,
            overflowY: "scroll",
          }}
        >
          {loading === true ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                backgroundColor: "#ffffff",
                height: "100%",
              }}
            >
              <img src={require("../../Image/loading.gif")} />
            </div>
          ) : (
            data.map((i, t) => {
              return (
                <ProductCard
                  item={i}
                  index={t}
                  edit_modal={(i) => handleOpen_edit(i)}
                  stock={(i) => handleOpen_stock(i)}
                  image={(i) => handleOpen_Image(i)}
                />
              );
            })
          )}
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Add
          close={(a) => {
            if (a == "a") {
              handleClose(false);
            } else {
              loadconent();
              handleClose(false);
            }
          }}
        />
      </Modal>
      <Modal
        open={edit_modal}
        onClose={handleClose_edit}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Edit
          close={(a) => {
            if (a == "a") {
              handleClose_edit(false);
            } else {
              loadconent();
              handleClose_edit(false);
            }
          }}
          data={editdata}
        />
      </Modal>

      <Modal
        open={stock_modal}
        onClose={handleClose_stock}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Stock
          close={(a) => {
            if (a == "a") {
              handleClose_stock(false);
            } else {
              loadconent();
              handleClose_stock(false);
            }
          }}
          data={stockdata}
        />
      </Modal>
      <Modal
        open={image}
        onClose={handleClose_Image}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Image
          close={(a) => {
            if (a == "a") {
              handleClose_Image(false);
            } else {
              loadconent();
              handleClose_Image(false);
            }
          }}
          data={editdata}
        />
      </Modal>
    </div>
  );
};

export default Product;
